const ACTIONS = {
  GET: "GetTrackDonations",
};

export { ACTIONS };
